import React from 'react';
import { useLocation } from 'react-router-dom';
import MobileEBooks from './MobileEBooks';
import MobileBookPage from './MobileBookPage';

const MobileBooksRoute = () => {
  const location = useLocation();
  const state = location.state as any;
  const isVivekVaniListingPath = location.pathname.startsWith('/magazines/vivekvani');

  const hasFilterState = !!(
    isVivekVaniListingPath ||
    state?.categoryId ||
    state?.categoryName ||
    state?.allKalyans ||
    state?.allKalpataru ||
    state?.vivekVaniId ||
    state?.kalyansId ||
    state?.kalpataruId ||
    state?.sortOption ||
    state?.selectedLanguageId ||
    state?.selectedAuthorId ||
    state?.selectedCategoryId ||
    state?.type ||
    state?.allArticles ||
    state?.articleCategoryId ||
    state?.productType
  );

  return hasFilterState ? <MobileBookPage /> : <MobileEBooks />;
};

export default MobileBooksRoute;
